<form [formGroup]="form" (submit)="submitForm()">
    <h3 class="create-account-header">Create your account:</h3>
    <div class="form-container">
        <div class="multi-field-row-credentials">
            <mat-form-field class="client-first-name">
                <input
                    matInput
                    placeholder="First Name"
                    [formControl]="clientFirstName"
                    [maxlength]="FieldLength.FIRST_NAME_MAX"
                    qa="first-name-field"
                />
                <mat-error>Enter a valid first name.</mat-error>
            </mat-form-field>
            <mat-form-field class="client-last-name">
                <input
                    matInput
                    placeholder="Last Name"
                    [formControl]="clientLastName"
                    [maxlength]="FieldLength.LAST_NAME_MAX"
                    qa="last-name-field"
                />
                <mat-error>Enter a valid last name.</mat-error>
            </mat-form-field>
        </div>
        <mat-form-field>
            <input
                matInput
                placeholder="Mobile Phone"
                [formControl]="clientMobilePhone"
                [maxlength]="FieldLength.PHONE_MAX"
                qa="phone-number-field"
            />
            <mat-error>Enter a valid mobile phone</mat-error>
        </mat-form-field>
        <mat-form-field>
            <input
                matInput
                placeholder="Email Address"
                [formControl]="clientEmailAddress"
                type="email"
                [maxlength]="FieldLength.EMAIL_MAX"
                qa="email-address-field"
            />
            <mat-error>Enter a valid email</mat-error>
        </mat-form-field>
        <mat-form-field>
            <input
                matInput
                placeholder="Password (eight or more characters)"
                [formControl]="clientPassword"
                type="password"
                [maxlength]="FieldLength.PASSWORD_MAX"
                qa="password-field"
            />
            <mat-error>Enter a password of 8 or more characters</mat-error>
        </mat-form-field>
        <div class="notification-options">
            <div class="notification-label">
                Subscribe to updates and marketing promotions by:
            </div>
            <div class="multi-field-row-notifications">
                <mat-checkbox
                    [formControl]="sendEmailNotifications"
                    class="client-send-email-notifications"
                    color="primary"
                    [disableRipple]="true"
                >
                    Email
                </mat-checkbox>
                <mat-checkbox
                    [formControl]="sendTextNotifications"
                    class="client-send-text-notifications"
                    color="primary"
                    [disableRipple]="true"
                >
                    Text Message
                </mat-checkbox>
            </div>
        </div>
        <div class="multi-field-row-navigation">
            <div class="back-link bold-text">
                <a (click)="backToLogin()">Back to Login</a>
            </div>
            <div>
                <button
                    mat-stroked-button
                    color="primary"
                    class="ols-mat-stroked-button-color submit-button"
                    type="submit"
                    [disabled]="isCreatingAccount"
                    qa="create-account-button"
                >
                    <span class="bold-text" *ngIf="!isCreatingAccount">
                        Create Account
                    </span>
                    <span class="bold-text" *ngIf="isCreatingAccount">
                        Creating...
                    </span>
                    <mat-spinner
                        [diameter]="23"
                        *ngIf="isCreatingAccount"
                    ></mat-spinner>
                </button>
            </div>
        </div>
    </div>
</form>
